import React from 'react';
import { Modal, Typography, theme } from 'antd';
import { shortcutItems, ShortcutItem } from './shortcutConfig';

const { Text, Title } = Typography;

type Props = {
  open: boolean;
  onClose: () => void;
  items?: ShortcutItem[];
};

export default function ShortcutInfoModal({ open, onClose, items = shortcutItems }: Props) {
  const { token } = theme.useToken();

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title="Keyboard shortcuts"
      width={620}
      centered
      destroyOnHidden
      styles={{
        body: {
          paddingTop: 12,
        },
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <Text type="secondary">Use these shortcuts to quickly open global search modals.</Text>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            marginTop: 4,
          }}
        >
          {items.map((item) => (
            <div
              key={item.key}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 16,
                padding: '12px 14px',
                border: `1px solid ${token.colorBorderSecondary}`,
                borderRadius: token.borderRadiusLG,
                background: token.colorFillAlter,
                transition: 'all 0.2s ease',
              }}
            >
              <div style={{ minWidth: 0, flex: 1 }}>
                <Title
                  level={5}
                  style={{
                    margin: 0,
                    fontSize: 14,
                    color: token.colorText,
                  }}
                >
                  {item.label}
                </Title>

                <Text
                  type="secondary"
                  style={{
                    fontSize: 12,
                    color: token.colorTextSecondary,
                  }}
                >
                  {item.description}
                </Text>
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  flexWrap: 'wrap',
                  justifyContent: 'flex-end',
                }}
              >
                {item.key.split(' + ').map((part, index, arr) => (
                  <React.Fragment key={`${item.key}-${part}-${index}`}>
                    <span
                      style={{
                        padding: '4px 8px',
                        borderRadius: token.borderRadiusSM,
                        border: `1px solid ${token.colorBorder}`,
                        background: token.colorBgContainer,
                        color: token.colorText,
                        fontSize: 12,
                        fontWeight: 500,
                        lineHeight: 1.2,
                        whiteSpace: 'nowrap',
                        boxShadow: token.boxShadowTertiary,
                      }}
                    >
                      {part}
                    </span>

                    {index < arr.length - 1 ? (
                      <span
                        style={{
                          fontSize: 12,
                          color: token.colorTextTertiary,
                        }}
                      >
                        +
                      </span>
                    ) : null}
                  </React.Fragment>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
